import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://www.thestableshorserides.co.za";
const DEFAULT_IMAGE = `${SITE_URL}/Stables5.jpg`;

type Props = {
  title: string;
  description: string;
  path?: string;
  image?: string;
  type?: string;
  schema?: object;
};

const SEO: React.FC<Props> = ({
  title,
  description,
  path = "/",
  image = DEFAULT_IMAGE,
  type = "website",
  schema,
}) => {
  const url = `${SITE_URL}${path}`;
  const fullTitle = title.includes("The Stables") ? title : `${title} | The Stables`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={image} />

      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
